import { IType } from '../domain/IType';
// import { ICategory } from './ICategory';
import { ISalePrice } from './ISalePrice';
import { IInventory } from './IInventory';
import { IExtendedInfo } from './IExtendedInfo';
import { IFile } from './IFile';
import { IVendor } from './IVendor';
import { IStockMovement } from './IStockMovement';
import { IOrder } from './IOrder';
import { ProductStock } from './ProductStock';
import { IProduct } from 'app/Sales/point-of-sale/domain/IProduct';

export class Product {
    _id: string;
    code: number;
    name: string;
    description: string;
    type: string;
    category: string;
    barcode: string;
    refCode: string;
    imagePath: string;
    reOrderLevel: number;
    reOrderQuantity: number;
    remarks: string;
    cost: number;
    // isActive: boolean;
    createdOn: Date;
    stocks: ProductStock[];
    updatedOn: Date;
    defaultLocation: string;
    length: number;
    width: number;
    height: number;
    weight: number;
    standardUom: string;
    SalesUom: string;
    PurchasingUom: string;
    salePrice: ISalePrice[];
    inventory: IInventory[];
    extendedInfo: IExtendedInfo[];
    files: IFile[];
    vendors: IVendor[];
    movements: IStockMovement[];
    orders: IOrder[];
    normalPrice: number;
    wholeSalePrice: number;
    totalQuantity: number;
    company: string;
    branch: string;
    gstOnProduct:number;
    unit:string;
    ingredients:IProduct[];

}

